import get from 'lodash.get';
import { getUserId } from 'dibs-cookie-jar';
import { graphql, fetchQuery } from 'react-relay';

// helpers
import {
    PRIORITIES,
    SHOW_SAVE_ITEM,
    STORAGE_KEYS,
    CALLOUT_KEYS,
} from '../pdpRespNotificationConstants';
import {
    getSessionAndStorageData,
    saveToStorage,
    displayNotification,
} from '../../../utils/notificationHelpers';

/**
 * Callout Workflow
 *
 * 1. Check localstorage. Return true if:
 *      - The tooltip has been displayed less than 3 times or
 *      - The tooltip was not already shown in the same browser session
 *
 * 2. If step 1 returns true, check to see if there is a userId (user is logged in).
 *      - If user is not logged in return true
 *      - If user is logged in, check to see if they have favorite items, return true if they do not
 */

const { SAVE_ITEM: SAVE_ITEM_PRIORITY } = PRIORITIES;
const { SAVE_ITEM: SAVE_ITEM_STORAGE_KEY } = STORAGE_KEYS;
const { SAVE_ITEM: SAVE_ITEM_CALLOUT_KEY } = CALLOUT_KEYS;
const browserStorage = getSessionAndStorageData(SAVE_ITEM_STORAGE_KEY, SAVE_ITEM_CALLOUT_KEY);

const query = graphql`
    query pdpRespNotificationSaveItemCalloutConfigQuery($userIds: [String]) {
        viewer {
            portfolios(userIds: $userIds, portfolioTypes: [HEART]) {
                edges {
                    node {
                        items(first: 1) {
                            totalResults
                        }
                    }
                }
            }
        }
    }
`;

export default {
    name: 'saveItemCallout',
    priority: SAVE_ITEM_PRIORITY,
    rule: ({ relayEnvironment }) => {
        const userId = getUserId(document.cookie);

        if (!displayNotification(browserStorage, SAVE_ITEM_CALLOUT_KEY)) {
            return Promise.resolve(false);
        } else {
            if (userId) {
                return fetchQuery(relayEnvironment, query, { userIds: [userId] }).then(
                    response =>
                        get(response, 'viewer.portfolios.edges[0].node.items.totalResults') === 0
                );
            }
            return Promise.resolve(true);
        }
    },
    action: () => dispatch => {
        saveToStorage(SAVE_ITEM_STORAGE_KEY, { type: SAVE_ITEM_CALLOUT_KEY });
        dispatch({
            type: SHOW_SAVE_ITEM,
        });
    },
};
